import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { privacyPolicyHtml } from "@/lib/privacy-policy-html";

export const Route = createFileRoute("/privacy-policy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy | RESTORE® Hair" },
      {
        name: "description",
        content:
          "How RESTORE® Hair collects, uses, discloses, and protects your personal information, and the privacy rights available to you.",
      },
      { property: "og:title", content: "Privacy Policy | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "Read the RESTORE® Hair privacy policy covering data collection, use, disclosure, retention, and your privacy rights.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/privacy-policy/" }],
  }),
  component: PrivacyPolicyPage,
});

function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <section className="bg-background py-10 md:py-16">
          <div className="mx-auto max-w-4xl px-4">
            <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
              Privacy Policy
            </h1>
            <div
              className="privacy-content mt-6 text-base leading-relaxed text-muted-foreground"
              dangerouslySetInnerHTML={{ __html: privacyPolicyHtml }}
            />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}